import { apiClient } from "@/service/ApiClient";

/* =======================
 * DTO / RESPONSE TYPE
 * ======================= */

export interface QuaterData {
    id: number;

    playerId: number;
    quarterNo: number;
    status: string;

    pointX?: number;
    pointY?: number;

    playerName: string;
    playerPosition1?: string;
    playerPosition2?: string;
    playerTeamABType?: 'A' | 'B';
    playerMemberId?: number;
}

export interface QuaterRes {
    result: boolean;
    data: QuaterData;
    message: string;
}

export interface QuaterListRes {
    result: boolean;
    data: QuaterData[];
    message: string;
}

/* =======================
 * REQUEST
 * ======================= */

export class QuaterUpdateReq {
    status?: string;
    pointX?: number;
    pointY?: number;

    constructor(
        status?: string,
        pointX?: number,
        pointY?: number
    ) {
        this.status = status;
        this.pointX = pointX;
        this.pointY = pointY;
    }
}

/* =======================
 * API
 * ======================= */

/**
 * 게임별 쿼터 목록 조회
 */
const getQuatersByGame = async (gameId: number) =>
    apiClient
        .get<QuaterData[]>(`/quaters/game/${gameId}`)
        .then(res => res.data);

/**
 * 쿼터 정보 수정
 */
const updateQuater = async (
    quaterId: number,
    req: QuaterUpdateReq
) =>
    apiClient
        .put<QuaterData>(`/quaters/${quaterId}`, req)
        .then(res => res.data);

/* =======================
 * EXPORT
 * ======================= */

const QuaterService = {
    getQuatersByGame,
    updateQuater,
    QuaterUpdateReq
};

export default QuaterService;
